var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMarketLeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.839 19.2972L24.1187 17.695L20.3999 19.3008L20.7739 15.2675L18.0977 12.2269L22.0492 11.3362L24.114 7.85128L26.1821 11.3343L30.1345 12.2211L27.461 15.2642L27.839 19.2972Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1469_7623",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1469_7623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 1.40625H38.0625V12.6562C38.0625 20.4228 31.7665 26.7188 24 26.7188C16.2336 26.7188 9.9375 20.4228 9.9375 12.6562V1.40625Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8125 26.7188V35.3438",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1875 35.3438V26.7188",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5625 40.9688V35.3437H32.4375V40.9688",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 46.5938V43.7812L12.75 40.9687H24H35.25L38.0625 43.7812V46.5938",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2813 46.5938H5.71875",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0624 8.43701C38.0624 6.10704 39.9512 4.21826 42.2812 4.21826C44.6112 4.21826 46.5937 6.10704 46.5937 8.43701C46.5937 14.9296 41.6112 20.2803 35.314 21.0088",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 8.4375C9.9375 6.10753 7.95497 4.21875 5.625 4.21875C3.29503 4.21875 1.40625 6.10753 1.40625 8.4375V9.84478C1.40625 16.0574 6.53634 21.0938 12.749 21.0938",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketLeader);
export default __webpack_public_path__ + "static/media/icon-market-leader.230f05f5a42ac63fcf175f290370fa7f.svg";
export { ForwardRef as ReactComponent };